export class APIConstants {
  static login = {
    loginUser: 'users/sessions',
  };

  static forgotPassword = {
    forgetPassword: 'users/{userName}/forgotpasswords',
  };

  static changePassword = {
    changePassword: 'allies/{allyId}/users/{userName}/passwords',
  };

  static user = {
    getUserDetails: 'allies/{allyId}',
    activateUser: 'allies/{allyId}/users/{userId}/activations',
    deactivateUser: 'allies/{allyId}/users/{userId}/activations',
    getAPIKeys: 'allies/{allyId}/users/{userId}/keys',
    users: 'allies/{allyId}/users',
    rollAPIKeys: 'allies/{allyId}/users/{userId}/keys/expirations',
    addUser: 'allies/{allyId}/users',
    editUser: 'allies/{allyId}/users/{userId}',
  };

  static agentUser = {
    getUserDetailsById: 'allies/{allyId}/users/{userId}',
  };

  public static readonly payment = {
    getTransactions: 'allies/{allyId}/transactions',
    getTransactionDetails: 'allies/{allyId}/transactions/{transId}',
    exportCSVReport: 'allies/{allyId}/payments/export',
    exportPDFReport: 'allies/{allyId}/payments/export/pdf',
    emailExportReport: 'allies/{allyId}/payments/export/email',
    getReferenceList: 'allies/{allyId}/referencedatalist',
    getTransactionTimeLines: 'allies/{allyId}/transactions/{transId}/timelines',
    checkRefundEligbility: 'allies/{allyId}/transactions/{transactionId}/refunds/eligibility',
    initiateRefundTransaction: 'allies/{allyId}/transactions/{transactionId}/refund',
  };

  public static readonly features = {
    featuresByName: 'allies/{allyId}/featuresaccess',
  };

  public static readonly developer = {
    getAllWebhoooks: 'allies/{allyId}/webhooks',
    addWebhook: 'allies/{allyId}/webhooks',
    updateWebhook: 'allies/{allyId}/webhooks/{id}',
    deleteWebhook: 'allies/{allyId}/webhooks/{id}',
    getAllWebhookEvents: 'allies/{allyId}/webhookEvents',
    getAllWebhookEventsLogs: 'allies/{allyId}/webhookeventnotifications',
    postFailedAllWebhookEvents: 'allies/{allyId}/retrywebhookeventnotification',
    webhookeventlogsDetails: 'allies/{allyId}/webhookeventnotifications/{id}',
    getModuleListForAlly: 'allies/{allyId}/webhookmodules',
    publicApiKey: 'allies/{allyId}/keys/{keyType}/expirations',
  };

  public static readonly reports = {
    getOldSubscriptionReports: 'allies/{allyId}/reports/subscriptions',
    getSubscriptionReports: 'rep/allies/{allyId}/reports/subscriptions',
    getSpecificReport: 'rep/allies/{allyId}/reports/{reportId}/logs',
    getSpecificOldReport: 'allies/{allyId}/reports/{reportId}/logs',
    getReportById: 'allies/{allyId}/reports/subscriptions/{reportId}',
    getAllReports: 'rep/allies/{allyId}/reports',
    getAllOldReports: 'allies/{allyId}/reports',
    addReportSubscriptions: 'rep/allies/{allyId}/reports/subscriptions',
    addOldReportSubscriptions: 'allies/{allyId}/reports/subscriptions',
    activeDeactiveReportAction: 'rep/allies/{allyId}/reports/subscriptions/{id}/activations',
    activeDeactiveOldReportAction: 'allies/{allyId}/reports/subscriptions/{id}/activations',
    downloadReport: 'rep/allies/{allyId}/reports/{reportId}/logs/{logId}/downloads',
    downloadOldReport: 'allies/{allyId}/reports/{reportId}/logs/{logId}/downloads',
  };

  public static readonly settingChangePassword = {
    changePassword: 'users/{userName}/changepassword',
  };

  static notifications = {
    getAllNotifications: '/allies/{allyId}/notifications',
    pauseunpauseAll: 'allies/{allyId}/notifications',
    defaultSubscribe: 'allies/{allyId}/notifications/{id}',
    alliesSubscribe: 'allies/{allyId}/notifications/{id}',
    addDistributionEmail: 'allies/{allyId}/notifications/{notificationId}/distributionlist',
    getEventDetails: 'allies/{allyId}/notifications/{notificationId}',
    getDistributionListWithPagination:
      'allies/{allyId}/notifications/{notificationId}/distributionlist/{distributionId}',
    deleteDistributionEmail:
      'allies/{allyId}/notifications/{notificationId}/distributionlist/{distributionId}/email',
    updateDistributionEmail:
      'allies/{allyId}/notifications/{notificationId}/distributionlist/{distributionId}',
    editPostNotificationTemplate: 'allies/{allyId}/notifications/{notificationId}/templates',
    editPutNotificationTemplate:
      'allies/{allyId}/notifications/{notificationId}/templates/{templateId}',
    getEventVariables: 'allies/{allyId}/notifications/variables',
    resetToSystemDefault: 'allies/{allyId}/notifications/{notificationId}',
  };

  static replacePathFrom = 'cid:headerLogo';
  static replacePathWith = '../../assets/images/AndDoneLogo.png';
}
